import * as React from 'react';
import { Field } from 'redux-form';
import { useIntl } from 'react-intl';
import { useControls } from '../ReduxFormControls';
import { Container, ImageContainer, LabelContainer, LabelField } from './JRCFormImage.styles';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
export type JRCFormInputImageProps = JRCFormInputImageFieldProps;

/**
 * Props type for JRCFormInputImageFieldProps
 * @member content text used as label
 * @member name text used as name
 */
export interface JRCFormInputImageFieldProps extends React.ComponentPropsWithoutRef<'input'> {
    content: string;
    name: string;
}

/**
 * Placeholder field used in studio to edit forms. No logic to transfer images is implemented.
 * @deprecated Use JRCInputImage instead
 */
export const JRCFormInputImage = ({ id, content }: JRCFormInputImageProps) => {
    return (
        <Container>
            <>
                <LabelContainer htmlFor={id}>
                    <LabelField>{content}</LabelField>
                </LabelContainer>
                <Container>
                    <ImageContainer>
                        <JRCIcon name="icon-image" size={24} />
                    </ImageContainer>
                </Container>
            </>
        </Container>
    );
};

/**
 * @deprecated Use JRCInputImage instead
 */
export const JRCFormInputImageField = (props: JRCFormInputImageFieldProps) => {
    const intl = useIntl();
    const validate = useControls({ ...props, intl });
    return <Field component={JRCFormInputImage} validate={validate} {...props} />;
};
